import axios from 'actions/envScales/axiosConfig';
import {
  GetObservationSettingsResponse,
  ObservationSettingsTarget
} from './types';

function toParams(target: ObservationSettingsTarget) {
  return 'assessmentId' in target
    ? { assessment_id: target.assessmentId }
    : {
        account_guid: target.accountGuid,
        observation_type: target.observationType
      };
}

// GET /api/v1/assessments/settings
export function getObservationSettings(target: ObservationSettingsTarget) {
  return axios.get<GetObservationSettingsResponse>(
    '/api/v1/assessments/settings',
    { params: toParams(target) }
  );
}
